import React, {Component} from 'react';
import 'normalize.css';
// import "main.css";  // Global styles
import Landing from "./components/Pages/Landing/Landing";
import Family from "./components/Pages/Family/Family";
import Awards from "./components/Pages/Awards/Awards";
import Charity from "./components/Pages/Charity/Charity";
import Gallery from "./components/Pages/Gallery/Gallery";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import roots from "./images/roots.svg";
import './App.css';

/**
 * App
 */
export default class App extends Component {

    /**
     * State
     *
     * @type {{}}
     */
    state = {
        familyClassName: 'family',
        header: {
            fixed: true
        }
    };

    /**
     * Constructor
     *
     * @param props
     */
    constructor(props) {
        super(props);

        this.setHeader = this.setHeader.bind(this);
        this.setFamilyClassName = this.setFamilyClassName.bind(this);
    }

    /**
     * Component did mount
     */
    componentDidMount() {
        this.setHeader('OUR ROOTS', roots, 'Investing in the Sargento Family', false);
    }

    /**
     * Set header
     *
     * @param chapter
     * @param image
     * @param title
     * @param fixed
     */
    setHeader(chapter, image, title, fixed) {
        this.setState({
            header: {
                chapter: chapter,
                fixed: fixed,
                image: image,
                title: title
            }
        });
    }

    /**
     * Set family className
     *
     * @param className
     */
    setFamilyClassName(className) {
        this.setState({
            familyClassName: className
        });
    }

    /**
     * Render
     *
     * @returns {*}
     */
    render() {

        const {familyClassName, header} = this.state;
        const {chapter, fixed, image, title} = header;

        return (
            <div>
                <Landing setHeader={this.setHeader}
                         setFamilyClassName={this.setFamilyClassName}/>

                <Header chapter={chapter}
                        fixed={fixed}
                        headerImg={image}
                        title={title}/>

                <Family setHeader={this.setHeader}
                        className={familyClassName}/>

                <Awards setHeader={this.setHeader}/>

                <Charity setHeader={this.setHeader}/>

                <Gallery setHeader={this.setHeader}/>

                <Footer />

            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/App.jsx